<template>
	<div class="HumidityStatistics">
		<Title firstName="照明系统总功率统计" lastName="POWER STATISTICS OF LIGHTING SYSTEM" />
		<div class="echarts">
		<div class="over">
			<div class="tag">
				<span :class="{active:acindex==0}" @click="changeIdx(0)">日</span>
				<span :class="{active:acindex==1}" @click="changeIdx(1)">月</span>
			</div>
		</div>
		<div
			id="HumidityStatistics1"
			ref="echarts"
			style="height: 17.8vh; width: 100%;"
		/>
		<div class="bottom"></div>
		</div>
	</div>
</template>

<script>
import * as echarts from "echarts";
const Title = () => import("../../../../components/title/Title");
const Graph = () => import("../../../../components/echarts/graph.vue");
const charts = () => import("../../../../components/echarts/charts.vue");
import { getLastOrNextFewDateBy } from "../../../../utils/common/DateUtil";

const SelectList = () => import("../../../../components/title/selectList.vue");
let myChart = null
export default {
	data() {
		return {
			acindex :0,
		};
	},
	components: {
		Title,
		Graph,
		charts,
		SelectList,
	},

    mounted() {
      	this.initCharts();
		window.addEventListener('resize',this.chartResize)
        window.addEventListener('beforeunload', this.clearChart);
    },
	methods: {
		changeIdx(idx){
			this.acindex = idx
		},
		clearChart(){
			// 手动触发 destroy 相关的生命周期
			this.$destroy();
		},
		chartResize(){
			//防抖
			if(this.timer)
				clearTimeout(this.timer)
			this.timer = setTimeout(()=>{
				myChart.resize();
			},500)
		},
		tabTitletag(item) {
		this.tagname = item.name;
		},
		initCharts() {
				myChart = echarts.getInstanceByDom(document.getElementById('HumidityStatistics1'));
				if(myChart == null){
					myChart = echarts.init(document.getElementById('HumidityStatistics1'));
				}
		var option;
		let xAxis = [];
		for (let i = 0; i < 12; i++) {
			xAxis.push(i + 1 + "月");
		}
		let data = []
			data = [
			{
				name: "本月",
				type: "line",
				stack: "总量",
				smooth: true,
				showSymbol: false,
				areaStyle: {},
				data: [120, 132, 101, 134, 90, 230, 210],
			},
			{
				name: "上月",
				type: "line",
				smooth: true,
				showSymbol: false,
				stack: "总量",
				areaStyle: {},
				data: [220, 182, 191, 234, 290, 330, 310],
			},
			]
		
		option = {
			color: ["#5B8FF9", "#FF9D4D"],
			tooltip: {
			trigger: "axis", //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
			backgroundColor: "rgba(0, 10, 26, 0.8)",
			borderRadius: 8,
			borderWidth: 0,
			shadowColor: "rgba(13, 148, 255, 0.8)",
			axisPointer: {
				// 坐标轴指示器，坐标轴触发有效
				type: "line", // 默认为直线，可选为：'line' | 'shadow'
			},
			textStyle: {
				color: "#fff",
			},
			},
			legend: {
			itemWidth: 12,
			itemHeight: 12,
			x: "right",
			icon: "roundRect",
			textStyle: {
				color: "#ffffff",
			},
			},
			grid: {
			top: "18%",
			left: "3%",
			right: "6%",
			bottom: "3%",
			containLabel: true,
			},
			xAxis: {
			type: "category",
			boundaryGap: false,
			data: getLastOrNextFewDateBy(new Date()),
			axisLine: {
				lineStyle: {
				color: "#0D94FF",
				},
			},
			axisLabel: {
				color: "#f0f0f0", //坐标轴的文本颜色
			},
			axisTick: {
				show: false, //去掉x轴刻度线
			},
			},
			yAxis: [
			{
				type: "value",
				name:"kVA",
				axisLine: {
				lineStyle: {
					color: "#f0f0f0",
				},
				},
				axisLabel: {
				color: "#f0f0f0", //坐标轴的文本颜色
				},
				axisTick: {
				show: false, //去掉x轴刻度线
				},
				splitLine: {
				//分割线
				lineStyle: {
					//分割线的样式
					color: ["rgba(230, 243, 253, 0.2)"],
					width: 1,
					type: "solid",
				},
				},
			},
			],
			series: data
		};

		option && myChart.setOption(option);
		},
	},
  	beforeDestroy(){
        window.removeEventListener('resize', this.chartResize);
        window.removeEventListener('beforeunload', this.clearChart);
        if(!myChart) return 
        myChart.clear()
        myChart = null;
    }
};
</script>

<style lang="less" scoped>
.HumidityStatistics {
	// height: 33.3vh;
	width: 20vw;
	// height: 493rem;
	position: fixed;
	top: 68.4vh;
	right: 1vw;
	z-index: 1;
	

	.echarts {
		position: relative;
		height: 24.5vh;
		padding-bottom: 1vh;
		background: linear-gradient(
		0deg,
		rgba(0, 33, 59, 0.6) 0%,
		rgba(3, 13, 24, 0.7) 100%
		);
		overflow: hidden;
		.bottom {
		width: 20vw;
		height: 1vh;
		background: url(../../../../assets/img/板块装饰线.png) no-repeat;
		block-size: 100% 100%;
		position: absolute;
		bottom: 0;
		left: 0;
		}
	}
}
</style>
